import React,{useEffect} from 'react'
import HeaderWidgetComponent from '../../widgets/HeaderWidget/HeaderWidgetComponent'
import FooterWidgetComponent from '../../widgets/FooterWidget/FooterWidgetComponent'
import HomeBannerComponent from './widgets/Banner/BannerComponent';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import {

 } from './HomeComponent.style';
import BeforeFooterComponent from './widgets/BeforeFooter/BeforeFooterComponent';
import SectionAComponentHome from './widgets/Sections/SectionAComponent';
import SectionBComponentHome from './widgets/Sections/SectionBComponent';
import SectionCComponent from './widgets/Sections/SectionCComponent';
import SectionDComponent from './widgets/Sections/SectionDComponent';
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 4,
    color: '#fff',
  },

}));



function Home() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  
  
  useEffect(() => {
      document.onreadystatechange = function () {
          if (document.readyState === 'complete') {
              setTimeout(() => {
                  setOpen(false);
              },3000)
          }
          if (document.readyState === "interactive") {
              console.log("page loaded the interactive");
              setOpen(true);
          }
          if (document.readyState === "loading") {
              console.log("page is loading");
              setOpen(true);                
          }
      }
  },[])
  return (
    <div>
        <Backdrop className={classes.backdrop} open={open} >
            <CircularProgress color="inherit" />
        </Backdrop>
        <HeaderWidgetComponent/>
        <HomeBannerComponent/>
        <SectionAComponentHome/>
        <SectionBComponentHome/>
        <SectionCComponent/>
        <SectionDComponent/>
        <BeforeFooterComponent/>
        <FooterWidgetComponent/>
    </div>
  )
}

export default Home